import React from 'react';

export const helpSidebarContent = {
  controlPerson: (
    <>
      Usually the person who controls the company from a management perspective - this would usually be a CEO or other
      executive. Required one per platform.
    </>
  ),
  beneficialOwner: (
    <>
      <p>
        Individuals who directly or indirectly own 25% or more of the company. If no individual or company directly owns
        more than 25% of your company than there are no beneficial owners other than the control person.
      </p>
      <p>
        If there is a legal entity that owns more than 25% of your company, you must confirm whether there is an
        individual who owns that entity which results in an indirect ownership of 25% or more. ie: you have a venture
        investor who owns 50% of the company and there is an individual who owns more than 50% of the fund, they would
        be a beneficial owner. If there is a venture fund that owns 25% of the company but if there is no partner who
        owns 100% of the fund, there would be no beneficial owners.
      </p>
    </>
  ),
} as const;
